export default "__VITE_ASSET__llqfoj5k__"